import { render, staticRenderFns } from "./pedidosAsistencia.vue?vue&type=template&id=293d55c6"
import script from "./pedidosAsistencia.vue?vue&type=script&lang=js"
export * from "./pedidosAsistencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports